import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebook, FaYoutube, FaInstagram, FaTwitter, FaLinkedin, FaTiktok } from "react-icons/fa";
import "./footers.css";

function Footermuft() {
    return (
        <footer className="footer bg-dark text-light py-4">
            <Container>
                <Row>
                    <Col md={6}>
                        <h3 className="mb-3">MUFT</h3>
                        <p>
                            NOTE: I hope my <a href="https://muft.pk" className="text-info">MUFT.PK</a> project has been beneficial to you in some way, and I am grateful for your support. If you wish to express your gratitude, a simple gesture would mean a lot: raise your hands wherever you are and make a heartfelt dua (prayer) for my team and me. May Allah guide us, forgive us, and grant us a place in His Jannah (paradise). Also, pray that He keeps us steadfast in our mission to educate and empower our ummah (community).
                        </p>
                    </Col>
                    <Col md={3}>
                        <ul className="list-unstyled">
                            <li><a href="#home" className="text-light">Home</a></li>
                            <li><a href="#contact" className="text-light">Contact Us</a></li>
                            <li><a href="#institute" className="text-light">Our Institute</a></li>
                        </ul>
                    </Col>
                    <Col md={3} className="d-flex justify-content-md-end mt-3 mt-md-0">
                        <a href="#" className="text-light mx-2"><FaFacebook size={24} /></a>
                        <a href="#" className="text-light mx-2"><FaYoutube size={24} /></a>
                        <a href="#" className="text-light mx-2"><FaInstagram size={24} /></a>
                        <a href="#" className="text-light mx-2"><FaTwitter size={24} /></a>
                        <a href="#" className="text-light mx-2"><FaTiktok size={24} /></a>
                        <a href="#" className="text-light mx-2"><FaLinkedin size={24} /></a>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col className="text-center">
                        <p className="mb-0">&copy; Copyright <b>Nassar Gondal</b>. All Rights Reserved.</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footermuft;
